import {Dispatch, SetStateAction} from 'react';
import {chakra, Stack, VStack, Box, Heading, Text, Image} from '@chakra-ui/react';
import {IMAGE_PREFIX} from '../env';
import DividualsChartHeading from 'components/DividualsChartHeading';
import Agreement from 'components/Agreement';
import {STICKING_OUT, STICKING_OUT_SM} from 'components/StepSectionHeading';
import {DIVIDUALS_CHART_CLASS_NAME} from '../aggregateData';

type Props = {
  linkTargetId: string
  isAgreedWith: boolean,
  setIsAgreedWith: Dispatch<SetStateAction<boolean>>
}

export default function Introduction({
  linkTargetId,
  isAgreedWith,
  setIsAgreedWith
}: Props) {
  return (
    <chakra.section
      mt={[`${152/16}rem`, `${152/16}rem`, `${187/16}rem`]}
      mb={[`calc(${300/16}rem - ${STICKING_OUT_SM})`, `calc(${300/16}rem - ${STICKING_OUT_SM})`, `calc(${365/16}rem - ${STICKING_OUT})`]}
    >
      <Stack direction={['column', 'column', 'row']} maxW={['contentSm', 'contentSm', 'content']} mx="auto" spacing={['2.125rem', '2.125rem', '20']}>
        <Box flexBasis={['auto', 'auto', "10rem"]} w={['29.850746268656717%', '29.850746268656717%', 'auto']} mx="auto">
          <Image src={`${IMAGE_PREFIX}img-graph-02.png`} alt="" />
        </Box>
        <Box flex="1">
          <Heading textAlign={['center', 'center', 'start']} color="blue.500">“わたしの分人”とは？</Heading>
          <VStack mt={`${34/16}rem`} spacing="1em" lineHeight={[1.5, 1.5, 2]}>
            <Text>分人主義を考えるとき、「分人の構成比率」という考え方がカギになります。どのような割合で、どのような「分人」を所有しているのか。それの集合が、私たちの個性を事後的に決定します。</Text>
            <Text>例えば、学生時代、学校でクラスメイトと過ごす時間はとても長く、大きいものに感じられます。そこでの「分人」が上手くいかないと「自分」そのものが嫌になることもあります。しかし、実際は、学校での自分は、幾つもある分人の一つに過ぎません。放課後、習い事で顔を合わせる友人や、家庭での「分人」が、学校で過ごす「分人」より心地良いのであれば、そのことを客観視し、最適な比率へと変化させることを考えるべきです。どうしても学校での分人が辛いのであれば、しばらくその分人を生きるのを休止し、心地良い分人を生きながら、状態が落ち着くのを待つ、というのも一つの方法です。</Text>
            <Text>この体験コンテンツでは、あなたの人生を「分人主義」を通して振り返ることで、それぞれの時代の「分人」構成比率を整理し、どのような分人があったかを再認識することが出来ます。</Text>
            <Text>過去の振り返り、また、現在を踏まえて、これからの未来、どんな「分人」の構成比率にしていきたいかを考えるきっかけにしてください。</Text>
          </VStack>
        </Box>
      </Stack>
      <VStack maxW={['contentSm', 'contentSm', 'content']} mx="auto" mt="10" w={['full', 'full', '50%']} className={DIVIDUALS_CHART_CLASS_NAME}>
        <Heading mb="2" color="blue.500">円グラフの完成例</Heading>
        <DividualsChartHeading name="社会人(20代)" />
        <Image src={`${IMAGE_PREFIX}graph_ex.png`} />
      </VStack>
      <Agreement linkTargetId={linkTargetId} isAgreedWith={isAgreedWith} setIsAgreedWith={setIsAgreedWith} mt={`${42/16}rem`} mb="4" textAlign="center" />
    </chakra.section>
  );
}
